module.exports = __webpack_public_path__ + "static/media/hat3.998f67e8.png";